import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./DownloadModal.module.css";

export default function DownloadModal() {
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(uiActions.setDownloadModalActive(false));
    };

    return (
        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
                <h2>Preparing Download</h2>
                <p>Please wait while your high-resolution<br />image is being generated.</p>
                <div className={styles.spinnerContainer}>
                    <div className={styles.spinner}></div>
                </div>
            </div>
        </PopUpModal>
    );
}
